import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { updateSEO, seoConfigs } from '../../utils/seo';

const HomePage = () => {
  const [openFaqIndex, setOpenFaqIndex] = useState<number | null>(null);

  useEffect(() => {
    updateSEO(seoConfigs.home);
  }, []);

  const services = [
    {
      icon: 'ri-sparkling-2-line',
      title: '全身脱毛コース',
      description: '最新の脱毛機器を使用し、痛みを最小限に抑えながら効果的な施術を提供。20代女性の肌質に合わせた丁寧なケアで、ツルツルの美肌を実現します。',
    },
    {
      icon: 'ri-heart-pulse-line',
      title: 'フェイシャルエステ',
      description: '岡山市で人気のフェイシャルケア。お肌の悩みに合わせたオーダーメイド施術で、透明感のある美肌へ導きます。毛穴ケアから保湿まで総合的にサポート。',
    },
    {
      icon: 'ri-body-scan-line',
      title: '痩身ボディケア',
      description: '理想のボディラインを目指す専門的な痩身プログラム。マッサージとマシンを組み合わせた効果的なアプローチで、美しいボディラインをサポートします。',
    },
  ];

  const testimonials = [
    {
      name: '田中 美咲様',
      age: 24,
      text: '初めての脱毛で不安でしたが、スタッフの方が丁寧にカウンセリングしてくださり安心できました。岡山市内でこんなに親身になってくれるサロンは他にないと思います。',
      image: 'https://public.readdy.ai/ai/img_res/b0ac8748e75fbf6862ddb5d4f67db33a.jpg',
    },
    {
      name: '佐藤 優花様',
      age: 22,
      text: 'フェイシャルエステを受けてから肌の調子が本当に良くなりました。20代のうちからしっかりケアできて良かったです。友人にもおすすめしています。',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/2d2113dca9e909bbb26f469e313c3340.jpeg',
    },
    {
      name: '山田 彩香様',
      age: 26,
      text: '痩身コースで理想の体型に近づけました。無理なダイエットではなく、プロの施術で健康的に美しくなれるのが嬉しいです。岡山でこのサロンに出会えて良かった。',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/ac94c6588e029dff23ddbd71c6165543.jpeg',
    },
    {
      name: '鈴木 麻衣様',
      age: 23,
      text: '清潔感のある店内と丁寧な接客に毎回癒されています。施術の技術も高く、効果を実感できるので通い続けたいと思えるサロンです。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20age%2023%20relaxed%20peaceful%20expression%2C%20natural%20beauty%2C%20soft%20lighting%2C%20casual%20elegant%20style%2C%20professional%20portrait%20photography%2C%20genuine%20calm%20smile%2C%20simple%20clean%20background&width=400&height=400&seq=testimonial4&orientation=squarish',
    },
  ];

  const faqs = [
    {
      question: '初回カウンセリングは無料ですか？',
      answer: 'はい、初回カウンセリングは無料です。お肌の状態やご希望をじっくりお伺いし、最適なプランをご提案させていただきます。',
    },
    {
      question: '痛みはありますか？',
      answer: '最新の脱毛機器を使用しており、痛みを最小限に抑えた施術が可能です。個人差はありますが、多くのお客様から「思ったより痛くなかった」とのお声をいただいています。',
    },
    {
      question: '予約のキャンセルは可能ですか？',
      answer: '前日までのご連絡でキャンセル可能です。当日キャンセルの場合はキャンセル料が発生する場合がございますので、予めご了承ください。',
    },
    {
      question: '施術時間はどのくらいですか？',
      answer: 'コースによって異なりますが、全身脱毛で約90分、フェイシャルエステで約60分が目安です。初回はカウンセリング時間を含めて余裕を持ってお越しください。',
    },
    {
      question: '支払い方法は何がありますか？',
      answer: '現金、クレジットカード、電子マネーに対応しております。分割払いのご相談も承っておりますので、お気軽にお問い合わせください。',
    },
    {
      question: '駐車場はありますか？',
      answer: 'はい、店舗前に専用駐車場を3台分ご用意しております。満車の場合は近隣のコインパーキングをご利用ください。',
    },
  ];

  const news = [
    {
      date: '2025.03.15',
      category: 'お知らせ',
      title: '4月新規オープン記念キャンペーン開始',
      description: '新規オープンを記念して、全コース20%OFFのキャンペーンを実施いたします。この機会にぜひご利用ください。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20beauty%20salon%20interior%20with%20elegant%20reception%20desk%2C%20clean%20white%20minimalist%20design%2C%20soft%20natural%20lighting%2C%20professional%20atmosphere%2C%20no%20text%20or%20signs%20visible%2C%20simple%20elegant%20background&width=600&height=400&seq=news1&orientation=landscape',
    },
    {
      date: '2025.03.10',
      category: 'イベント',
      title: '無料カウンセリング会開催のお知らせ',
      description: '3月25日・26日に無料カウンセリング会を開催します。脱毛やエステについてのご相談を承ります。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20female%20esthetician%20consulting%20with%20client%20at%20modern%20beauty%20salon%2C%20professional%20setting%2C%20clean%20white%20interior%2C%20natural%20lighting%2C%20friendly%20atmosphere%2C%20no%20text%20visible%2C%20simple%20background&width=600&height=400&seq=news2&orientation=landscape',
    },
    {
      date: '2025.03.05',
      category: 'サービス',
      title: '新メニュー「美白フェイシャル」登場',
      description: '春の新メニューとして、美白に特化したフェイシャルコースをご用意しました。透明感のある肌を目指す方におすすめです。',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20woman%20receiving%20facial%20treatment%20at%20spa%2C%20professional%20esthetician%20hands%20visible%2C%20clean%20white%20treatment%20room%2C%20soft%20lighting%2C%20serene%20atmosphere%2C%20no%20text%20visible%2C%20simple%20elegant%20background&width=600&height=400&seq=news3&orientation=landscape',
    },
    {
      date: '2025.03.01',
      category: 'お知らせ',
      title: 'LINE公式アカウント開設しました',
      description: 'LINEでの予約・お問い合わせが可能になりました。友だち追加でお得な情報も配信中です。',
      image: 'https://readdy.ai/api/search-image?query=Modern%20smartphone%20displaying%20beauty%20salon%20booking%20app%2C%20clean%20minimalist%20interface%2C%20soft%20lighting%2C%20professional%20photography%2C%20elegant%20simple%20background%2C%20no%20text%20visible%20on%20screen&width=600&height=400&seq=news4&orientation=landscape',
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-screen w-full overflow-hidden">
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/82aafd9eaf6513bc1c981c4147eb1ae4.png"
            alt="岡山市の脱毛サロン・エステの施術風景"
            className="w-full h-full object-cover object-top"
          />
        </div>

        <div className="relative z-10 h-full flex items-center justify-end">
          <div className="text-right px-6 max-w-4xl mr-12">
            <p className="text-gray-dark text-sm md:text-base font-light mb-4 tracking-wider">
              岡山市で選ばれる理由
            </p>
            <h1 className="text-gray-dark text-4xl md:text-6xl lg:text-7xl font-bold mb-6 leading-tight">
              岡山市で叶える、<br />あなただけの美肌体験
            </h1>
            <p className="text-gray-dark text-base md:text-lg font-light mb-8">
              20代女性のための、丁寧で確かな脱毛・エステティック
            </p>
            <div className="flex flex-col sm:flex-row items-end justify-end gap-4">
              <a
                href="tel:086-012-3456"
                className="px-8 py-3.5 bg-white text-gray-dark border-2 border-gray-dark text-sm md:text-base font-medium rounded-full whitespace-nowrap hover:bg-gray-light transition-colors cursor-pointer inline-flex items-center"
              >
                <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                086-012-3456
              </a>
              <Link
                to="/contact"
                className="px-8 py-3.5 bg-gray-dark text-white text-sm md:text-base font-medium rounded-full whitespace-nowrap hover:bg-gray-medium transition-colors cursor-pointer"
              >
                お問い合わせフォーム
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* News Section */}
      <section className="py-20 md:py-28 bg-white px-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16">
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif font-bold text-gray-dark mb-4 md:mb-0">
              お知らせ
            </h2>
            <p className="text-sm md:text-base font-light text-gray-medium">
              最新情報をお届けします
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Featured News */}
            <article className="bg-gray-dark rounded-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-64 md:h-80 w-full overflow-hidden">
                <img
                  src={news[0].image}
                  alt={news[0].title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6 md:p-8">
                <div className="flex items-center space-x-3 mb-3">
                  <span className="text-xs font-light text-gray-light/60">{news[0].date}</span>
                  <span className="px-3 py-1 bg-gray-light/20 text-white text-xs font-light rounded-full whitespace-nowrap">
                    {news[0].category}
                  </span>
                </div>
                <h3 className="text-lg md:text-xl font-bold text-white mb-3">
                  {news[0].title}
                </h3>
                <p className="text-sm font-light text-gray-light/80 leading-relaxed">
                  {news[0].description}
                </p>
              </div>
            </article>

            {/* Other News */}
            <div className="space-y-6">
              {news.slice(1).map((item, index) => (
                <article key={index} className="bg-gray-light rounded-lg overflow-hidden hover:shadow-lg transition-shadow">
                  <div className="p-5">
                    <div className="flex items-center space-x-3 mb-2">
                      <span className="text-xs font-light text-gray-medium">{item.date}</span>
                      <span className="px-2 py-0.5 bg-gray-medium/20 text-gray-dark text-xs font-light rounded-full whitespace-nowrap">
                        {item.category}
                      </span>
                    </div>
                    <h3 className="text-base font-medium text-gray-dark mb-2">
                      {item.title}
                    </h3>
                    <p className="text-sm font-light text-gray-dark/70 leading-relaxed line-clamp-2">
                      {item.description}
                    </p>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-20 md:py-28 bg-gray-light px-6">
        <div className="max-w-7xl mx-auto">
          <div className="mb-16">
            <p className="text-gray-medium text-xs md:text-sm font-light mb-3 tracking-widest uppercase">
              Our Services
            </p>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-dark">
              選べる3つのプラン
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {services.map((service, index) => (
              <article key={index} className="bg-gray-medium/10 rounded-lg p-8 hover:shadow-lg transition-shadow">
                <i className={`${service.icon} text-4xl mb-6 w-12 h-12 flex items-center justify-center`} style={{ color: '#8C646E' }}></i>
                <h3 className="text-xl md:text-2xl font-bold text-gray-dark mb-4">
                  {service.title}
                </h3>
                <p className="text-sm md:text-base font-light text-gray-dark/80 leading-relaxed mb-6">
                  {service.description}
                </p>
                <Link
                  to="/services"
                  className="inline-block px-6 py-2.5 text-white text-sm font-light rounded-full whitespace-nowrap hover:opacity-90 transition-opacity cursor-pointer"
                  style={{ backgroundColor: '#8C646E' }}
                >
                  詳しく見る
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 md:py-28 bg-white px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-gray-medium text-xs md:text-sm font-light mb-3 tracking-widest uppercase">
              Customer Voice
            </p>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-dark">
              お客様の声
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {testimonials.map((testimonial, index) => (
              <article key={index} className="bg-gray-light rounded-lg p-6 hover:shadow-lg transition-shadow">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 rounded-full overflow-hidden mr-3 flex-shrink-0">
                    <img
                      src={testimonial.image}
                      alt={`${testimonial.name}様の写真`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-medium text-gray-dark">{testimonial.name}</p>
                    <p className="text-xs font-light text-gray-medium">{testimonial.age}歳</p>
                  </div>
                </div>
                <i className="ri-double-quotes-l text-2xl text-gray-medium/30 mb-2 w-8 h-8 flex items-center justify-center"></i>
                <p className="text-sm font-light text-gray-dark/80 leading-relaxed">
                  {testimonial.text}
                </p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 md:py-28 bg-gray-light px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-16">
            <p className="text-gray-medium text-xs md:text-sm font-light mb-3 tracking-widest uppercase">
              FAQ
            </p>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-gray-dark">
              よくある質問
            </h2>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <article key={index} className="bg-white rounded-lg overflow-hidden">
                <button
                  onClick={() => setOpenFaqIndex(openFaqIndex === index ? null : index)}
                  className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer hover:bg-gray-light/50 transition-colors"
                >
                  <h3 className="text-sm md:text-base font-medium text-gray-dark pr-4">
                    {faq.question}
                  </h3>
                  <i className={`text-xl text-gray-medium transition-transform w-6 h-6 flex items-center justify-center flex-shrink-0 ${
                    openFaqIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}></i>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${
                    openFaqIndex === index ? 'max-h-96' : 'max-h-0'
                  }`}
                >
                  <p className="px-6 pb-5 text-sm md:text-base font-light text-gray-dark/80 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 md:py-28 px-6" style={{ backgroundColor: '#8C646E' }}>
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
            まずは無料カウンセリングから
          </h2>
          <p className="text-base md:text-lg font-light text-gray-light/80 mb-10 leading-relaxed">
            岡山市で20代女性に選ばれる理由を、ぜひ体験してください。<br className="hidden md:block" />
            お肌の悩みや理想の美しさについて、じっくりお話を伺います。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="tel:086-012-3456"
              className="px-8 py-3.5 bg-white text-gray-dark text-sm md:text-base font-medium rounded-full whitespace-nowrap hover:bg-gray-light transition-colors cursor-pointer inline-flex items-center"
            >
              <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
              086-012-3456
            </a>
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-transparent border-2 border-white text-white text-sm md:text-base font-medium rounded-full whitespace-nowrap hover:bg-white hover:text-gray-dark transition-colors cursor-pointer"
            >
              お問い合わせフォーム
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
